import { render, staticRenderFns } from "./CandidateFinancesTable.vue?vue&type=template&id=508d966e&scoped=true&"
import script from "./CandidateFinancesTable.vue?vue&type=script&lang=js&"
export * from "./CandidateFinancesTable.vue?vue&type=script&lang=js&"
import style0 from "./CandidateFinancesTable.vue?vue&type=style&index=0&id=508d966e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508d966e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
